var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCleanerManagement = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.813,
    height: 24.06,
    viewBox: "0 0 23.813 24.06",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cleaner_management",
    "data-name": "Cleaner management",
    transform: "translate(22502 7431.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_16",
    "data-name": "Subtraction 16",
    d: "M13.316,24.06H10.5a.706.706,0,0,1-.7-.619L9.6,21.86a10,10,0,0,1-1.611-.526L6.908,22.5a.708.708,0,0,1-.516.225.7.7,0,0,1-.414-.135L3.7,20.934a.706.706,0,0,1-.2-.913l.772-1.392a10.171,10.171,0,0,1-1-1.371l-1.556.3a.7.7,0,0,1-.8-.473L.034,14.406a.706.706,0,0,1,.373-.857l1.442-.671c-.029-.3-.042-.578-.042-.848s.014-.551.042-.849L.408,10.51a.706.706,0,0,1-.373-.857L.905,6.971a.7.7,0,0,1,.67-.487.711.711,0,0,1,.136.013l1.555.3a10.17,10.17,0,0,1,1-1.371L3.5,4.038a.706.706,0,0,1,.2-.913L5.979,1.469a.7.7,0,0,1,.414-.135.708.708,0,0,1,.516.225L7.994,2.725A10,10,0,0,1,9.6,2.2L9.8.619A.706.706,0,0,1,10.5,0h2.818a.705.705,0,0,1,.7.619l.193,1.58a10,10,0,0,1,1.611.526L16.9,1.559a.708.708,0,0,1,.516-.225.7.7,0,0,1,.414.135l2.28,1.657a.706.706,0,0,1,.2.913l-.772,1.392a10.157,10.157,0,0,1,1,1.371L22.1,6.5a.7.7,0,0,1,.806.473l.87,2.682a.706.706,0,0,1-.373.857l-1.442.671c.028.3.041.581.041.849s-.014.547-.041.848l1.442.671a.706.706,0,0,1,.373.857l-.871,2.682a.7.7,0,0,1-.8.473l-1.556-.3a10.157,10.157,0,0,1-1,1.371l.772,1.392a.706.706,0,0,1-.2.913l-2.28,1.657a.7.7,0,0,1-.414.135A.707.707,0,0,1,16.9,22.5l-1.085-1.166a10,10,0,0,1-1.611.526l-.193,1.58A.705.705,0,0,1,13.316,24.06ZM11.906,4.369a7.661,7.661,0,1,0,7.657,7.661A7.668,7.668,0,0,0,11.906,4.369Z",
    transform: "translate(-22502 -7431.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7247",
    "data-name": "Group 7247",
    transform: "translate(-22497 -7426.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_14",
    "data-name": "Polygon 14",
    d: "M6.5,0l1.5,5.005L13,6.5,7.995,7.995,6.5,13,5.005,7.995,0,6.5,5.005,5.005Z",
    transform: "translate(0 0.299)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCleanerManagement, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CleanerManagement.2747e826.svg";
export { ForwardRef as ReactComponent };